<div class="wp-relations-create">
  @if (!showRelationsCreateForm) {
    <div class="wp-relations-create-button hide-when-print"
      >
      <div class="grid-block">
        <div class="grid-content collapse">
          <button
            type="button"
            class="spot-link wp-inline-create--add-link"
            opAutofocus
            (click)="toggleRelationsCreateForm()"
            id="relation--add-relation"
            >
            <svg plus-icon size="small" />
            <span [textContent]="text.addNewRelation"></span>
          </button>
        </div>
      </div>
    </div>
  }
  <div class="loading-indicator--location"
    data-indicator-name="relationAddDynamic">
    @if (showRelationsCreateForm) {
      <div class="v-align wp-relations-create--form"
        >
        <div class="grid-content collapse medium-3">
          <label class="sr-only"
            for="relation-type--select"
          [textContent]="text.relationType"></label>
          <select class="form--select relationTypeSelect"
            id="relation-type--select"
            role="listbox"
            [(ngModel)]="selectedRelationType"
            opAutofocus>
            @for (type of relationTypes; track type) {
              <option
                [textContent]="type.label"
              [value]="type.name"></option>
            }
          </select>
        </div>
        <div class="grid-content medium-8">
          <wp-relations-autocomplete [workPackage]="workPackage"
            (change)="onSelected($event)"
            (cancel)="toggleRelationsCreateForm()"
            [hiddenOverflowContainer]="'.work-packages-tab-view--overflow'"
            [selectedRelationType]="selectedRelationType"
            data-test-selector="wp-relations-autocomplete" />
        </div>
        <div class="grid-content medium-1 collapse wp-relations-controls-section relation-row">
          <button
            type="button"
            class="spot-link wp-create-relation--cancel"
            (click)="toggleRelationsCreateForm()"
            >
            <op-icon icon-classes="icon-remove icon-no-color -padded" [icon-title]="text.abort" />
          </button>
        </div>
      </div>
    }
  </div>
</div>
